import { call, put, select } from 'redux-saga/effects';
import * as chartActions from '../chart/chart.actions';
import * as chartResourceService from '../../../resource/chart/chart.saga-service';
import * as nodeResourceService from '../../../resource/node/node.saga-service';
import {
  INodeCreate,
  INodePositionUpdate,
  INodeUpdate,
  IOrganizationChartNode,
  IChartNodeDeleteMutationResult,
  IChartNodePositionsMutationResult,
  IChartNodeSaveMutationResult,
} from '../../../resource/node/node.types';
import * as dialogService from '../../../dialog/dialog.saga-services';
import { chartPageSelectors } from '../chart/chart.selectors';
import { IChart } from '../../../resource/chart/chart.types';

function* storeChartMetadataFromApi(chart: IChart | undefined) {
  if (!chart) {
    return;
  }
  yield call(chartResourceService.mergeChartMetadata, chart);
}

export function* createNode(nodeInfo: INodeCreate, chartType: string) {
  const result = (yield call(nodeResourceService.createNode, nodeInfo, chartType)) as
    | IChartNodeSaveMutationResult
    | undefined;

  if (!result?.node) {
    return;
  }
  const nodesIds = yield select(chartPageSelectors.selectNodes);
  const refreshChart = yield select(chartPageSelectors.selectRefreshChart);

  yield put(nodesIds ? chartActions.storeChart([...nodesIds, result.node.id]) : chartActions.clearChart());
  yield put(chartActions.refreshChart(refreshChart + 1));
  yield call(storeChartMetadataFromApi, result.chart);
  yield call(dialogService.closeDialog, 'nodeFormDialog');
}

export function* updateNode(nodeId: IOrganizationChartNode['id'], nodeInfo: INodeUpdate) {
  const result = (yield call(nodeResourceService.updateNode, nodeId, nodeInfo)) as
    | IChartNodeSaveMutationResult
    | undefined;
  if (!result?.node) {
    return;
  }
  const nodesIds = yield select(chartPageSelectors.selectNodes);
  const refreshChart = yield select(chartPageSelectors.selectRefreshChart);
  yield put(chartActions.clearChart());
  yield put(nodesIds ? chartActions.storeChart([...nodesIds]) : chartActions.clearChart());
  yield put(chartActions.refreshChart(refreshChart + 1));
  yield call(storeChartMetadataFromApi, result.chart);
  yield call(dialogService.closeDialog, 'nodeFormDialog');
}

export function* updateNodesPositions(chartType: string, positions: INodePositionUpdate[]) {
  const result = (yield call(nodeResourceService.updateNodesPositions, chartType, positions)) as
    | IChartNodePositionsMutationResult
    | undefined;
  if (!result?.nodes?.length) {
    return;
  }
  const refreshChart = yield select(chartPageSelectors.selectRefreshChart);
  yield put(chartActions.refreshChart(refreshChart + 1));
  yield call(storeChartMetadataFromApi, result.chart);
}

export function* deleteNode(nodeId: IOrganizationChartNode['id']) {
  const result = (yield call(nodeResourceService.deleteNode, nodeId)) as IChartNodeDeleteMutationResult | undefined;
  if (!result) {
    return;
  }
  const nodesIds: IOrganizationChartNode['id'][] = yield select(chartPageSelectors.selectNodes);
  const refreshChart = yield select(chartPageSelectors.selectRefreshChart);
  yield put(chartActions.refreshChart(refreshChart + 1));

  yield put(nodesIds ? chartActions.storeChart(nodesIds.filter((id) => nodeId !== id)) : chartActions.clearChart());
  yield call(storeChartMetadataFromApi, result.chart);
}
